import { P } from '@angular/cdk/keycodes';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogBaseViewComponent, Environment, ProductName, Scope, WebsiteBookingConfigurationDialogData, WebsiteBuilderPreviewScope } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { ElevioService } from '@sb/library/elevio';
import { LayoutModule } from '@sb/library/layout';
import { WebsiteManager } from '@sb/library/managers';
import { SubmissionBarModule } from '@sb/library/submission-bar';


@Component({
    selector: 'lib-configuration-error-dialog',
    templateUrl: './configuration-error-dialog.component.html',
    styleUrls: ['./configuration-error-dialog.component.scss'],
    standalone: true,
    imports: [
        LayoutModule,
        SubmissionBarModule,
        ButtonModule,
        ReactiveFormsModule
    ]
})
export class ConfigurationErrorDialogComponent extends DialogBaseViewComponent<WebsiteBookingConfigurationDialogData> {

    Scope = this.SetScope({
        Requires: WebsiteBuilderPreviewScope
    });

    constructor(
        private _ElevioService: ElevioService,
        private _Environment: Environment,
        private _WebsiteManager: WebsiteManager
    ) {
        super();
    }

    HelpArticleClicked(): void {
        switch(this._Environment.Application.ProductName) {
            case (ProductName.TutorBird):
                this._ElevioService.OpenElevioArticle(1044);
                break;
            case (ProductName.AthletaDesk):
                this._ElevioService.OpenElevioArticle(1008);
                break;
            default:
                this._ElevioService.OpenElevioArticle(1474);
        }
    }

    GoToAvailability(): void {
        this.Scope.RouteMyProfile();
    }

    GoToTeachers(): void {
        this.Scope.RouteTeachers();
    }

    GoToCalendar(): void {
        this.Scope.RouteCalendar();
    }

    get isMultiTeacherSchool(): boolean {
        return this.data.RenderContext.SchoolIsMultiTeacher;
    }

    get hasVisibleTeachers(): boolean {
        return this.data.HasVisibleTeachers;
    }

    get hasOpenLessonSlots(): boolean {
        return this.data.HasOpenLessonSlots;
    }

    get hasTeachersWithAvailability(): boolean {
        return this.data.HasTeachersWithAvailabilityAndOnlineBooking;
    }

    get isBookFromCalendar(): boolean {
        return this._WebsiteManager.IsCalendarBookingWidget(this.data.SignUpFormType);
    }

    get isBookFromAvail(): boolean {
        return this._WebsiteManager.IsAvailabilityBookingWidget(this.data.SignUpFormType);
    }

    get canRouteToTeachers(): boolean {
        return this.Scope.canRouteToTeachers;
    }
}
